import { render } from "./AssetGroupHistory.vue?vue&type=template&id=66a3b3e8&scoped=true&ts=true"
import script from "./AssetGroupHistory.vue?vue&type=script&lang=ts"
export * from "./AssetGroupHistory.vue?vue&type=script&lang=ts"

import "./AssetGroupHistory.vue?vue&type=style&index=0&id=66a3b3e8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a3b3e8"]])

export default __exports__